import { render, staticRenderFns } from "./levInfo.vue?vue&type=template&id=b8b13964&scoped=true"
import script from "./levInfo.vue?vue&type=script&lang=js"
export * from "./levInfo.vue?vue&type=script&lang=js"
import style0 from "./levInfo.vue?vue&type=style&index=0&id=b8b13964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b13964",
  null
  
)

export default component.exports